/** The room the card page keeps round its fields (card-page.tsx `page`). */
export const ISLAND_EDGE = 4;

/** The page's height with its fields alone (card number, then expiry and
 *  CVC), the room kept round them included: what it reports once loaded,
 *  so a view that starts at it does not move when the page speaks. */
export const ISLAND_FIELDS_HEIGHT = 102;
